'use strict';
(function ($, Drupal) {
    Drupal.behaviors['cplBaseBeforeAfter'] = {
        attach: function (context, settings) {
            const $beforeAfter = $('.cpl-special-before-after', context);
            $beforeAfter.once('cpl-before-after-paragraph').each((index, el) => {
                $(el).find('.before-after').imagesCompare();
            });
        }
    };
    Drupal.behaviors['cplBaseBlogEqualizer'] = {
        attach: function (context, settings) {
            const $blog = $('.cpl-blog-page-block, .path-taxonomy.section-blog .taxonomy-page, .path-taxonomy.section-tag .taxonomy-page', context);
            $blog.once('cpl-blog-equalize').each((index, el) => {
                const $this = $(el);
                $this.find('.views-row').attr('data-equalizer-watch', 'equalize-blog');
                $this.attr({
                    'data-equalizer': 'equalize-blog',
                    'data-equalize-on': 'small'
                });
                $this.foundation();
            });
        }
    };
    Drupal.behaviors['cplBaseExpandText'] = {
        attach: function (context, settings) {
            const $expand = $('.text-expand', context);
            $expand.once('text-expanded').each((index, el) => {
                const $this = $(el);
                const options = {
                    slicePoint: 800,
                    preserveWords: true,
                    expandText: 'Read more \xBB',
                    expandPrefix: '',
                    userCollapse: false,
                    moreClass: 'text-expand--expanded',
                    summaryClass: 'text-expand--summary',
                    detailClass: 'text-expand--details',
                    expandEffect: 'slideDown',
                    expandSpeed: 0,
                    widow: 4
                };
                $this.expander(options);
            });
        }
    };
    Drupal.behaviors['cplBaseFloatLabelsBase'] = {
        attach: function (context, settings) {
            let $floatingLabels = $('.floating-labels', context);
            $floatingLabels.once('floating-labels').each(function () {
                new FloatLabels($(this)[0], {
                    prefix: 'fl-',
                    prioritize: 'label',
                    transform: 'input, textarea'
                });
            });
            // All User pages forms.
            let $userPages = $('.form-item', context).filter(function () {
                return !!$(this).parents('.user-form, .user-login-form, .user-pass').length;
            });
            $userPages.once('floating-label-user').each(function () {
                let $this = $(this);
                new FloatLabels($this[0], {
                    prefix: 'fl-',
                    prioritize: 'label',
                    transform: 'input, textarea'
                });
                // Fix Chrome bug with password field.
                if (/chrom(e|ium)/.test(navigator.userAgent.toLowerCase())) {
                    setTimeout(function () {
                        $this.find('input:-webkit-autofill').parent('.fl-wrap').addClass('fl-is-active');
                    }, 200);
                }
            });
        }
    };
    Drupal.behaviors['cplBaseGuide'] = {
        attach: function (context, settings) {
            const $sidebarMenu = $('.node--type-guide .sidebar nav .menu', context);
            $sidebarMenu.once('guide-page').each(function () {
                const $this = $(this);
                const $sidebar = $('.node--type-guide .sidebar');
                // Initialize accordion menu.
                $this.addClass('vertical accordion-menu').attr('data-accordion-menu', '');
                $this.find('ul').addClass('menu vertical nested');
                $this.foundation();
                // Add button to open the menu on small and medium screen.
                const tocMarkup = `<div class="guide-toc hide-for-large"><h4><a href="#">${ Drupal.t('Table of Contents') }</a></h4></div>`;
                $sidebar.find('.block-title').after(tocMarkup);
                $sidebar.find('.is-accordion-submenu-parent').each(function () {
                    const $submenu = $(this).find('.submenu');
                    $(this).find('a').first().clone().prependTo($submenu[0]).wrap('<li class="is-submenu-item is-accordion-submenu-item" role="menuitem"></li>');
                });
                // Show / hide popup menu.
                $('.guide-toc').click(function (event) {
                    event.preventDefault();
                    $sidebar.toggleClass('is-active');
                    $('body').toggleClass('is-fixed');
                });
            });
        }
    };
    Drupal.behaviors['cplBaseLazyload'] = {
        attach: function (context, settings) {
            $('img.image-lazy-load', context).once('cpl-image-lazy-load').each(function () {
                window.lazyload($(this).toArray());
            });
        }
    };
    Drupal.behaviors['cplBaseMobileMenu'] = {
        attach: function (context, settings) {
            const $button = $('#mobile-menu-button', context);
            const $body = $('body', context);
            // Context removed intentionally
            const $mobileMenu = $('.cpl-mobile-menu');
            function openPopup($el) {
                $el.addClass('is-active');
                setTimeout(() => {
                    $body.addClass('is-fixed');
                }, 400);
            }
            function closePopup($el) {
                $el.addClass('is-closing');
                $body.removeClass('is-fixed');
                setTimeout(() => {
                    $el.removeClass('is-closing is-active');
                }, 500);
            }
            // Open mobile menu.
            $button.once('mobile-menu-open').each((index, el) => {
                $(el).click(event => {
                    event.preventDefault();
                    openPopup($('.cpl-mobile-menu'));
                });
            });
            // Menu popup scripts.
            $mobileMenu.once('mobile-menu-popup').each((index, el) => {
                const $this = $(el);
                // Close mobile menu.
                $this.find('.close-button').click(event => {
                    event.preventDefault();
                    closePopup($this);
                });
                document.onkeydown = event => {
                    event = event || window.event;
                    if ($this.hasClass('is-active') && event.keyCode === 27) {
                        closePopup($this);
                    }
                };
                // Menus behavior.
                $this.find('.menu:not(.submenu) > li:last-child').addClass('bordered');
                $this.find('.menu:not(.submenu)').children().clone(true, true).appendTo('.menu-combined');
                $this.find('.mobile-menu > ul').remove();
                const isMobile = () => {
                    if (typeof Foundation !== 'undefined' && Foundation.MediaQuery.current === 'small') {
                        return true;
                    }
                };
                // Mobile menu type 1
                if ($mobileMenu.hasClass('cpl-menu-type-1')) {
                    // Drilldown menu
                    $this.find('.is-dropdown-submenu-parent').removeClass('is-dropdown-submenu-parent opens-right');
                    $this.find('.submenu.menu').removeClass('is-dropdown-submenu').addClass('vertical nested');
                    new Foundation.Drilldown($this.find('.drilldown'));
                } else if ($mobileMenu.hasClass('cpl-menu-type-4')) {
                    // Mobile menu type 4
                    $this.find('.menu > li > a').each((i, e) => {
                        $(e).wrapInner('<span class="menu-item-text"></div>');
                    });
                    $body.addClass('is-vertical-menu');
                    $this.find('.dropdown').on('show.zf.dropdownmenu', () => {
                        $this.addClass('is-open');
                        $('body').addClass('menu-opened');
                        if (isMobile()) {
                            $('body').addClass('is-fixed');
                        }
                    });
                    $this.find('.dropdown').on('hide.zf.dropdownmenu', () => {
                        $this.removeClass('is-open');
                        $('body').removeClass('menu-opened');
                        if (isMobile()) {
                            $('body').removeClass('is-fixed');
                        }
                    });
                    new Foundation.DropdownMenu($this.find('.dropdown'));
                    // Open main menu on small screen
                    const $logoMenu = $this.find('.menu-logo > a');
                    $logoMenu.click(event => {
                        if (Foundation.MediaQuery.current === 'small') {
                            event.preventDefault();
                            $this.toggleClass('logo-menu-opened');
                        }
                    });
                } else {
                    // Accordion menu
                    new Foundation.AccordionMenu($this.find('.accordion-menu'));
                }
            });
        }
    };
    Drupal.behaviors['cplBaseParagraphs'] = {
        attach: function (context, settings) {
            const $equalizeParagraph = $('.cpl-paragraph-equalize', context);
            $equalizeParagraph.once('equalize-paragraph').each((index, el) => {
                const $this = $(el);
                const $grid = $this.find('.content-grid');
                const paragraphId = $this.data('paragraph-entity-id');
                $this.find('.content-grid-item').attr('data-equalizer-watch', `equalize-paragraph-${ paragraphId }`);
                $grid.attr({
                    'data-equalizer': `equalize-paragraph-${ paragraphId }`,
                    'data-equalize-on': 'small'
                });
                $grid.foundation();
            });
            // Equalize text boxes on small screen with slideshow.
            const $slideshowParagraph = $('.paragraph--type--imgtxtbanner.cpl-slideshow, .paragraph--type--imgtxt.cpl-slideshow', context);
            $slideshowParagraph.once('equalize-text-boxes').each((index, el) => {
                const $this = $(el);
                const $container = $this.find('.content-grid');
                const paragraphId = $this.data('paragraph-entity-id');
                const equalizeTextBoxes = () => {
                    if (Foundation.MediaQuery.current === 'small') {
                        if (!$container.data(`equalize-slideshow-${ paragraphId }`)) {
                            $container.find('.text-box-row').attr('data-equalizer-watch', `equalize-slideshow-${ paragraphId }`);
                            $container.attr('data-equalizer', `equalize-slideshow-${ paragraphId }`);
                            $container.foundation();
                        }
                    } else {
                        $container.find('.text-box-row').removeAttr('data-equalizer-watch style');
                        $container.removeAttr('data-equalizer');
                    }
                };
                equalizeTextBoxes();
                $(window).resize(equalizeTextBoxes);
            });
            // Stop video playing when closing video popup.
            const $videoModal = $('.video-modal', context);
            $videoModal.once('video-modal-close').each((index, el) => {
                const $this = $(el);
                const stopVideo = element => {
                    const iframe = element.querySelector('iframe');
                    if (iframe) {
                        const iframeSrc = iframe.src;
                        iframe.src = iframeSrc;
                    }
                };
                $this.on('closed.zf.reveal', () => {
                    stopVideo($this.get(0));
                });
            });
            // Video url modifications for ImgtxtBanner.
            const $videoBannerIframe = $('.paragraph--type--imgtxtbanner .image-box-video-bg iframe', context);
            $videoBannerIframe.once('video-background').each((index, el) => {
                const modifyIframeUrl = $iframe => {
                    const iframeSrc = $iframe.attr('src').replace('autoplay=0', 'autoplay=1');
                    let iframeSrcNew;
                    // Vimeo.
                    if ($iframe.closest('.video-embed-field-provider-vimeo').length) {
                        iframeSrcNew = `${ iframeSrc }&loop=1&muted=1&background=1&autopause=0&fun=false`;    // YouTube.
                    } else if ($iframe.closest('.video-embed-field-provider-youtube').length) {
                        iframeSrcNew = `${ iframeSrc }&loop=1&showinfo=0&controls=0&disablekb=1`;
                    }
                    $iframe.attr({
                        src: iframeSrcNew,
                        allow: 'autoplay; fullscreen'
                    });
                };
                setTimeout(() => {
                    modifyIframeUrl($(el));
                }, 250);
            });
            // Video url modifications for Media Text.
            const $mediaTextIframe = $('.paragraph--type--imgtxt .image-box-video iframe', context);
            $mediaTextIframe.once('video-frame-style-mediatxt').each((index, el) => {
                const $this = $(el);
                const iframeSrc = $this.attr('src');
                let iframeSrcNew;
                if ($this.closest('.video-embed-field-provider-vimeo').length) {
                    iframeSrcNew = `${ iframeSrc }&background=1`;
                } else if ($this.closest('.video-embed-field-provider-youtube').length) {
                    iframeSrcNew = `${ iframeSrc }&modestbranding=1&controls=0&fs=0&rel=0`;
                }
                $this.attr({ src: iframeSrcNew });
            });
            // Start autoplay of videos in paragraph, when option is selected.
            const $videoAutoplay = $('.cpl-video-autoplay', context);
            $videoAutoplay.once('paragraph-video-autoplay').each((index, el) => {
                const $this = $(el);
                // Autoplay all videos.
                if ($this.hasClass('cpl-alternating')) {
                    const $videos = $this.find('iframe');
                    $videos.each((i, e) => {
                        $(e).attr({
                            src: $(e).attr('src').replace('autoplay=0', 'autoplay=1'),
                            allow: 'autoplay; fullscreen'
                        });
                    });
                } else {
                    // Autoplay only first video.
                    const $videoFirst = $this.find('iframe').eq(0);
                    $(window).scroll(() => {
                        if ($(window).scrollTop() > $this.offset().top - 200 && $this.attr('data-autoplay-started') === undefined) {
                            $videoFirst.attr({
                                src: $videoFirst.attr('src').replace('autoplay=0', 'autoplay=1'),
                                allow: 'autoplay; fullscreen'
                            });
                            $this.attr({ 'data-autoplay-started': '' });
                        }
                    });
                }
            });
            // Remove view reference title for blog.
            const $viewReferenceTitle = $('.cpl-blog-page-block', context);
            $viewReferenceTitle.once('view-reference-title').each((index, el) => {
                $(el).parent().siblings('.viewsreference--view-title').css('display', 'none');
            });
            // Default background image height.
            const $imageBackground = $('.paragraph--type--imgtxtbanner .image-box-bg, .paragraph--type--imgtxt .image-box-bg', context);
            $imageBackground.once('height-default-image-bg').each((index, el) => {
                const $this = $(el);
                const $parentParagraph = $this.parents('.paragraph');
                if (!$parentParagraph.hasClass('[class^="cpl-banner"]') || !$parentParagraph.hasClass('[class^="cpl-image"]')) {
                    $this.css('min-height', `${ $this.attr('data-image-height') }px`);
                }
            });
        }
    };
    Drupal.behaviors['cplBaseScrollToId'] = {
        attach: function (context, settings) {
            const $scroll = $('[data-smooth-scroll]', context);
            $scroll.once('scroll-to-id').each((index, el) => {
                const $this = $(el);
                const isSafari = !!navigator.userAgent.match(/safari/i) && !navigator.userAgent.match(/chrome/i) && typeof document.body.style.webkitFilter !== 'undefined' && !window.chrome;
                let dataOffset = $this.data('smooth-scroll-offset');
                if (isSafari) {
                    dataOffset += 100;
                }
                const options = { offset: dataOffset || 0 };
                $this.find('a').click(event => {
                    event.preventDefault();
                    $(event.target).mPageScroll2id(options);
                });
            });
        }
    };
    Drupal.behaviors['cplBaseScrollTrigger'] = {
        attach: function (context, settings) {
            const $scroll = $('.cpl-scroll-trigger', context);
            $scroll.once('scroll-trigger').each((index, el) => {
                const $this = $(el);
                let scrollTimeout;
                $(window).scroll(() => {
                    clearTimeout(scrollTimeout);
                    scrollTimeout = setTimeout(() => {
                        if ($(window).scrollTop() > $this.offset().top - 200 && !$this.hasClass('scrolled')) {
                            $this.addClass('scrolled');
                        }
                    }, 100);
                });
            });
        }
    };
    Drupal.behaviors['cplBaseSearchAutocomplete'] = {
        attach: function (context, settings) {
            let $searchBox = $('#search-autocomplete', context);
            $searchBox.once().each(function () {
                let $this = $(this);
                let options = {
                    url: function (phrase) {
                        return '/shop_search_suggestion?_format=json&search=' + phrase;
                    },
                    getValue: 'title',
                    requestDelay: 200,
                    list: {
                        maxNumberOfElements: 6,
                        showAnimation: {
                            type: 'fade',
                            time: 300
                        },
                        hideAnimation: {
                            type: 'slide',
                            time: 300
                        }
                    },
                    template: {
                        type: 'custom',
                        method: function (value, item) {
                            if (typeof item == 'string') {
                                return item;
                            }
                            return `
        <div class="search-result">
          <a href="${ item.url }">
            <img class="search-result-img" src="${ item.image }" alt="">
            <div class="search-result-info">
              <strong>${ item.title }</strong><br>${ item.variations }
            </div>
          </a>
        </div>`;
                        }
                    }
                };
                $this.easyAutocomplete(options);
            });
        }
    };
    Drupal.behaviors['cplBaseSearch'] = {
        attach: function (context, settings) {
            let $searchButton = $('.header-nav-commerce .menu .menu-link-item-', context);
            let $searchBlock = $('.search-popup-block', context);
            let $body = $('body', context);
            $searchButton.once('search-popup-open').each(function () {
                $(this).click(function (event) {
                    event.preventDefault();
                    openPopup();
                });
            });
            $searchBlock.once('search-popup-close').each(function () {
                let $this = $(this);
                let $input = $this.find('#search-autocomplete');
                let $clear = $this.find('.button-clear');
                // Close button.
                $this.find('.close-button').click(function (event) {
                    event.preventDefault();
                    closePopup($this);
                });
                // Close on escape.
                document.onkeydown = function (event) {
                    event = event || window.event;
                    if ($this.hasClass('is-active') && event.keyCode === 27) {
                        closePopup($this);
                    }
                };
                $input.keypress(function () {
                    $clear.show();
                });
                $input.focus(function () {
                    if (!$(this).val()) {
                        $clear.hide();
                    }
                });
                $clear.click(function (event) {
                    event.preventDefault();
                    $(this).hide();
                    $input.val('');
                });
            });
            function openPopup() {
                $('.search-popup-block').addClass('is-active');
                $body.addClass('is-fixed');
                setTimeout(function () {
                    $searchBlock.find('input[type=search]').focus();
                }, 500);
            }
            function closePopup($el) {
                $el.addClass('is-closing');
                $body.removeClass('is-fixed');
                setTimeout(function () {
                    $el.removeClass('is-closing is-active');
                }, 500);
            }
        }
    };
    Drupal.behaviors['cplBaseStickyFooter'] = {
        attach: function (context, settings) {
            const $footer = $('.page-footer', context);
            $footer.once('sticky-footer').each((index, el) => {
                const $header = $('.page-header');
                const $main = $('.page-container');
                const $this = $(el);
                if ($header.length && $this.length && $main.length) {
                    $(document).sticky_footer($header, $this, $main);
                    $(window).resize(() => {
                        $(document).sticky_footer($header, $this, $main);
                    });
                }
            });
        }
    };
    Drupal.behaviors['cplBaseStickyHeader'] = {
        attach: function (context, settings) {
            const $stickyHeader = $('.header-main', context);
            $stickyHeader.once('sticky-header').each((index, el) => {
                const $this = $(el);
                const $body = $('body');
                const $blockSection = $('.cpl-page-header');
                if (!$body.hasClass('adminimal-admin-toolbar') && $blockSection.hasClass('cpl-header-sticky')) {
                    $this.stickMe({
                        shadow: true,
                        shadowOpacity: 0.3,
                        topOffset: 600,
                        triggerAtCenter: false
                    });
                    $this.on('sticking', () => $body.addClass('has-sticky-header'));
                    $this.on('top-reached', () => $body.removeClass('has-sticky-header'));
                }
            });
        }
    };
    Drupal.behaviors['cplBaseTriggerButton'] = {
        attach: function (context, settings) {
            const $triggerButton = $('.cpl-trigger', context);
            $triggerButton.once('trigger-button').each((index, el) => {
                const $this = $(el);
                // Prevent open url after the popup has started.
                const $triggerLink = $this.find('.cpl-trigger-link');
                if ($triggerLink.attr('data-open')) {
                    $triggerLink.click(event => {
                        event.preventDefault();
                    });
                }
            });
        }
    };
    Drupal.behaviors['cplBaseUserPages'] = {
        attach: function (context, settings) {
            const $userPageSlideshow = $('.user-page-slideshow', context);
            $userPageSlideshow.once('user-page-slideshow').each((index, el) => {
                const $this = $(el);
                const slideshowOptions = {
                    autoplay: true,
                    autoplaySpeed: 5000,
                    infinite: true,
                    speed: 500,
                    slidesToShow: 1,
                    slidesToScroll: 1,
                    dots: true,
                    arrows: false
                };
                $this.slick(slideshowOptions);
            });
        }
    };
}(jQuery, Drupal));